import {TextField, TextFieldProps} from '@mui/material';

type AppMUITextInputProps = {
  styles?: React.CSSProperties;
  backgroundColor?: string;
  children?: React.ReactNode;
} & Omit<TextFieldProps, 'sx' | 'slotProps'>;

function AppMUITextInput({
  styles,
  backgroundColor,
  children,
  ...rest
}: AppMUITextInputProps) {
  return (
    <TextField
      slotProps={{
        htmlInput: {
          style: {
            padding: 0,
          },
        },
        input: {
          style: {
            backgroundColor: backgroundColor ? backgroundColor : '#1D1B2014',
            border: '1px solid #C0C0C0',
            borderRadius: '4px',
            fontSize: '16px',
            color: '#000',
            outline: 'none',
            padding: '10px 12px',
          },
        },
        select: {
          style: {
            padding: 0,
          },
          MenuProps: {
            PaperProps: {
              sx: {
                maxHeight: '400px',
                border: '1px solid #707070',
                boxShadow: '0 4px 4px #00000040',
              },
            },
          },
        },
      }}
      sx={{
        ...styles,
        // Root class for the input field
      }}
      {...rest}>
      {children}
    </TextField>
  );
}

export default AppMUITextInput;
